var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport } from "vue";
import { useFloating, arrow, offset, shift, autoPlacement, hide, autoUpdate, size, } from '@floating-ui/vue';
import { computed, inject, nextTick, onMounted, onUnmounted, provide, readonly, ref, watch } from 'vue';
import { createReusableTemplate, onClickOutside, useMounted } from '@vueuse/core';
import { nextZIndex } from '@common/hooks';
import { providePopperKey } from '@common/ui/EPopper/providePopperKey';
import { provideParentUuidPopperKey } from '@common/ui/EPopper/provideParentUuidPopperKey';
import { generateUuid } from '@common/utils/Helpers/Helpers';
import { storeToRefs } from 'pinia';
import { PopperRelationStore } from '@common/stores/store';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false,
}, { __name: 'EPopper', props: /*#__PURE__*/ _mergeModels({
        allowedPlacements: { default: function () { return ['top', 'bottom']; } },
        offsetAmount: { default: 0 },
        appendToBody: { type: Boolean, default: true },
        trigger: { default: 'manual' },
        unselectable: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        hideArrow: { type: Boolean, default: false },
        followReferenceWidth: { type: Boolean },
        fullwidth: { type: Boolean },
        fullwidthParent: { type: Boolean },
        closeOnClickReference: { type: Boolean, default: false },
        inline: { type: Boolean },
        renderType: { default: 'full' }
    }, {
        "visible": __assign({ type: Boolean }, { default: false }),
        "visibleModifiers": {},
    }), emits: /*#__PURE__*/ _mergeModels(["outsideClick"], ["update:visible"]), setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var popperUuid = generateUuid();
        var poppersRelation = storeToRefs(PopperRelationStore).poppersRelation;
        var setRelation = PopperRelationStore.setRelation, getChildrenRef = PopperRelationStore.getChildrenRef, deleteRelation = PopperRelationStore.deleteRelation;
        var props = __props;
        var emit = __emit;
        var parentUuid = inject(provideParentUuidPopperKey, null);
        var visibleModel = _useModel(__props, 'visible');
        var _b = __read(createReusableTemplate(), 2), DefineTemplate = _b[0], ReuseTemplate = _b[1];
        var contentRef = ref(null);
        var referenceRef = ref(null);
        var referenceWrapperRef = ref(null);
        var isMounted = useMounted();
        var arrowElm = ref(null);
        var referenceMaxHeight = ref(0);
        var currentPlacement = ref('');
        var zIndex = ref(1000);
        var ignoreOther = ref(null);
        var showReference = computed(function () { return visibleModel.value && !props.disabled; });
        var children = computed(function () { return poppersRelation.value && getChildrenRef(popperUuid); });
        watch(showReference, function (v) {
            if (v) {
                zIndex.value = nextZIndex();
                ignoreOther.value = null;
            }
            else {
                ignoreOther.value = window.document.body;
            }
        });
        watch(function () { return props.disabled; }, function (v) {
            if (v) {
                visibleModel.value = false;
            }
        });
        onUnmounted(function () {
            deleteRelation(popperUuid);
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        zIndex.value = nextZIndex();
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        setRelation(parentUuid, popperUuid, referenceWrapperRef.value);
                        return [2 /*return*/];
                }
            });
        }); });
        onClickOutside(referenceRef, function (e) {
            var isClickOnSomeChild = children.value.some(function (c) { return c.contains(e.target); });
            if (isClickOnSomeChild)
                return;
            if (props.trigger !== 'click')
                return;
            visibleModel.value = false;
            emit('outsideClick', e);
        }, {
            ignore: [
                contentRef,
                ignoreOther,
            ],
        });
        var middleware = computed(function () { return [
            offset(props.offsetAmount),
            shift(),
            autoPlacement({
                allowedPlacements: props.allowedPlacements,
            }),
            size({
                apply: function (_a) {
                    var rects = _a.rects, availableWidth = _a.availableWidth, availableHeight = _a.availableHeight, elements = _a.elements, placement = _a.placement;
                    referenceMaxHeight.value = availableHeight - 50;
                    currentPlacement.value = placement;
                    // Change styles, e.g.
                    Object.assign(elements.floating.style, {
                        maxWidth: "".concat(availableWidth, "px"),
                        maxHeight: "".concat(availableHeight - 50, "px"),
                        width: props.followReferenceWidth ? "".concat(rects.reference.width, "px") : undefined,
                    });
                },
            }),
            hide(),
            arrow({ element: arrowElm }),
        ]; });
        var _c = useFloating(contentRef, referenceRef, {
            whileElementsMounted: autoUpdate,
            middleware: middleware,
        }), floatingStyles = _c.floatingStyles, middlewareData = _c.middlewareData, placement = _c.placement;
        var arrowX = computed(function () { var _a, _b; return (_b = (_a = middlewareData.value.arrow) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : null; });
        var arrowY = computed(function () { var _a, _b; return (_b = (_a = middlewareData.value.arrow) === null || _a === void 0 ? void 0 : _a.y) !== null && _b !== void 0 ? _b : null; });
        var staticSide = computed(function () {
            var side = placement.value.split('-')[0];
            return {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right',
            }[side];
        });
        var arrowStyles = computed(function () {
            var _a;
            return _a = {
                    left: arrowX.value != null ? "".concat(arrowX.value, "px") : '',
                    top: arrowY.value != null ? "".concat(arrowY.value, "px") : ''
                },
                _a[staticSide.value] = "".concat(-props.offsetAmount, "px"),
                _a.height = '10px',
                _a.width = '10px',
                _a;
        });
        var arrowTransform = computed(function () {
            switch (staticSide.value) {
                case 'top': {
                    return '';
                }
                case 'right': {
                    return 'translateX(-100%) translateY(0%) rotate(45deg)';
                }
                case 'bottom': {
                    return 'rotate(180deg)';
                }
                case 'left': {
                    return 'translateX(0) translateY(0) rotate(45deg)';
                }
                // No default
            }
        });
        var onClickContent = function () {
            if (props.disabled)
                return;
            if (props.trigger !== 'click')
                return;
            visibleModel.value = !visibleModel.value;
        };
        var onHoverContent = function () {
            if (props.disabled)
                return;
            if (props.trigger !== 'hover')
                return;
            visibleModel.value = true;
        };
        var onHoverLeaveContent = function () {
            if (props.disabled)
                return;
            if (props.trigger !== 'hover')
                return;
            visibleModel.value = false;
        };
        var onClickReference = function () {
            // вообще это хак, я пока не придумал как нормально сделать
            if (props.closeOnClickReference) {
                visibleModel.value = false;
            }
        };
        provide(provideParentUuidPopperKey, popperUuid);
        provide(providePopperKey, {
            maxHeight: readonly(referenceMaxHeight),
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([[
                        _ctx.inline && 'inline-flex',
                        _ctx.fullwidthParent && 'w-full',
                    ], "e-popper"])
            }, [
                _createElementVNode("div", _mergeProps(_ctx.$attrs, {
                    ref_key: "contentRef",
                    ref: contentRef,
                    class: [
                        !_ctx.fullwidth && 'w-fit h-fit',
                    ],
                    onClick: onClickContent,
                    onMouseenter: onHoverContent,
                    onMouseleave: onHoverLeaveContent
                }), [
                    _renderSlot(_ctx.$slots, "default")
                ], 16),
                _createVNode(_unref(DefineTemplate), null, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", {
                            ref_key: "referenceRef",
                            ref: referenceRef,
                            class: _normalizeClass([[
                                    _ctx.unselectable && 'e-popper__reference--unselectable',
                                ], "e-popper__reference"]),
                            style: _normalizeStyle(__assign(__assign({ '--arrowTransform': arrowTransform.value }, _unref(floatingStyles)), { zIndex: zIndex.value })),
                            role: "tooltip",
                            onClick: onClickReference,
                            onMouseenter: onHoverContent,
                            onMouseleave: onHoverLeaveContent
                        }, [
                            _renderSlot(_ctx.$slots, "reference", { maxHeight: referenceMaxHeight.value }),
                            (!_ctx.hideArrow)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    ref_key: "arrowElm",
                                    ref: arrowElm,
                                    style: _normalizeStyle(arrowStyles.value),
                                    class: "e-popper__arrow"
                                }, [
                                    _renderSlot(_ctx.$slots, "arrow", { placement: currentPlacement.value })
                                ], 4))
                                : _createCommentVNode("", true)
                        ], 38)
                    ]; }),
                    _: 3
                }),
                (_unref(isMounted))
                    ? (_openBlock(), _createBlock(_Teleport, {
                        key: 0,
                        disabled: !_ctx.appendToBody,
                        to: "#tooltips"
                    }, [
                        _createElementVNode("div", {
                            ref_key: "referenceWrapperRef",
                            ref: referenceWrapperRef
                        }, [
                            (_ctx.renderType === 'full')
                                ? (_openBlock(), _createBlock(_Transition, {
                                    key: 0,
                                    mode: "out-in",
                                    name: "fade"
                                }, {
                                    default: _withCtx(function () { return [
                                        (showReference.value)
                                            ? (_openBlock(), _createBlock(_unref(ReuseTemplate), { key: 0 }))
                                            : _createCommentVNode("", true)
                                    ]; }),
                                    _: 1
                                }))
                                : (_ctx.renderType === 'shallow')
                                    ? (_openBlock(), _createBlock(_Transition, {
                                        key: 1,
                                        mode: "out-in",
                                        name: "fade"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _withDirectives(_createVNode(_unref(ReuseTemplate), null, null, 512), [
                                                [_vShow, showReference.value]
                                            ])
                                        ]; }),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                        ], 512)
                    ], 8, ["disabled"]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    } }));
